// extracted by mini-css-extract-plugin
export default {"container":"NewUserForm_container__vFDTJ","button":"NewUserForm_button__aCT+W","breathing":"NewUserForm_breathing__cnijV"};